import { Tabs, TabsContent, TabsList, TabsTrigger, useIsMobile } from "@elit-hair/elit-ui";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { LastCallCard } from "@/components/last-call-card";
import { DialerContent } from "@/pages/home/components/dial-panel/dialer-content";
import { useCall } from "@/providers/hooks/use-call";

import { HeaderKpi } from "./kpi";

enum HeaderCallDialerContentTabs {
    LAST_CALL = "last-call",
    DIALER = "dialer",
}

export function HeaderCallDialerContent() {
    const { t } = useTranslation();
    const isMobile = useIsMobile();
    const { calledPhoneNumber, setCalledPhoneNumber, handleHangupCall, callStatus, isCallActive, handleSendDigits } =
        useCall();

    const [activeTab, setActiveTab] = useState<HeaderCallDialerContentTabs>(HeaderCallDialerContentTabs.LAST_CALL);

    const handleNumberClick = (num: string) => {
        if (isCallActive()) {
            handleSendDigits(num);
            return;
        }

        switch (num) {
            case "<":
                setCalledPhoneNumber(calledPhoneNumber.slice(0, -1));
                break;
            case "clear":
                setCalledPhoneNumber("");
                break;
            case "+":
                if (calledPhoneNumber.includes("+")) {
                    break;
                }

                setCalledPhoneNumber("+" + calledPhoneNumber);
                break;
            default:
                setCalledPhoneNumber(calledPhoneNumber + num);
                break;
        }
    };

    return (
        <div className="flex h-full flex-col gap-3">
            {isMobile && (
                <div className="flex justify-center px-1" data-tour="kpi-area">
                    <HeaderKpi />
                </div>
            )}

            <Tabs
                className="min-h-0 flex-1"
                value={activeTab}
                onValueChange={(value) => setActiveTab(value as HeaderCallDialerContentTabs)}
            >
                <TabsList className="w-full">
                    <TabsTrigger value={HeaderCallDialerContentTabs.LAST_CALL} className="w-full">
                        <span className="group-data-[collapsible=icon]:hidden">{t("last_call")}</span>
                    </TabsTrigger>

                    <TabsTrigger value={HeaderCallDialerContentTabs.DIALER} className="w-full">
                        <span className="group-data-[collapsible=icon]:hidden">{t("dialer")}</span>
                    </TabsTrigger>
                </TabsList>

                <TabsContent value={HeaderCallDialerContentTabs.LAST_CALL} className="h-full w-full flex-1">
                    <LastCallCard />
                </TabsContent>

                <TabsContent value={HeaderCallDialerContentTabs.DIALER} className="h-full w-full flex-1">
                    <DialerContent
                        calledPhoneNumber={calledPhoneNumber}
                        setCalledPhoneNumber={setCalledPhoneNumber}
                        handleHangup={handleHangupCall}
                        handleNumberClick={handleNumberClick}
                        callStatus={callStatus}
                    />
                </TabsContent>
            </Tabs>
        </div>
    );
}
